Object.defineProperty(exports, "__esModule", {
  value: true,
});

const _extends =
  Object.assign ||
  function(target) {
    for (let i = 1; i < arguments.length; i++) {
      const source = arguments[i];
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };

const _slicedToArray = (function() {
  function sliceIterator(arr, i) {
    const _arr = [];
    let _n = true;
    let _d = false;
    let _e;
    try {
      for (
        var _i = arr[Symbol.iterator](), _s;
        !(_n = (_s = _i.next()).done);
        _n = true
      ) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i.return) _i.return();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function(arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    }
    if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    }
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
})();

const _createClass = (function() {
  function defineProperties(target, props) {
    for (let i = 0; i < props.length; i++) {
      const descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

let _DEFAULT_STYLE_MAP;
let _ENTITY_ATTR_MAP;
let _DATA_TO_ATTR;

exports.default = stateToHTML;

const _combineOrderedStyles3 = require("./helpers/combineOrderedStyles");

const _combineOrderedStyles4 = _interopRequireDefault(_combineOrderedStyles3);

const _normalizeAttributes = require("./helpers/normalizeAttributes");

const _normalizeAttributes2 = _interopRequireDefault(_normalizeAttributes);

const _styleToCSS = require("./helpers/styleToCSS");

const _styleToCSS2 = _interopRequireDefault(_styleToCSS);

const _draftJsUtils = require("draft-js-utils");

const _draftConstants = require("../../constants/draft");

const _documentConstants = require("../../constants/document");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

const BOLD = _draftJsUtils.INLINE_STYLE.BOLD;

const CODE = _draftJsUtils.INLINE_STYLE.CODE;

const ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC;

const STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH;

const UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE;

const INDENT = "  ";
const BREAK = "<br>";
const DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/;

const {
  ORDERED_LIST_TYPES,
  UNORDERED_LIST_TYPES,
  DRAFT_TAB_LENGTH,
} = _draftConstants;

const DEFAULT_STYLE_MAP = ((_DEFAULT_STYLE_MAP = {}),
_defineProperty(_DEFAULT_STYLE_MAP, BOLD, { element: "strong" }),
_defineProperty(_DEFAULT_STYLE_MAP, CODE, { element: "code" }),
_defineProperty(_DEFAULT_STYLE_MAP, ITALIC, { element: "em" }),
_defineProperty(_DEFAULT_STYLE_MAP, STRIKETHROUGH, { element: "del" }),
_defineProperty(_DEFAULT_STYLE_MAP, UNDERLINE, { element: "u" }),
_DEFAULT_STYLE_MAP);

// Order: inner-most style to outer-most.
// Examle: <em><strong>foo</strong></em>
const DEFAULT_STYLE_ORDER = [BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE];

// Map entity data to element attributes.
const ENTITY_ATTR_MAP = ((_ENTITY_ATTR_MAP = {}),
_defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.LINK, {
  url: "href",
  href: "href",
  rel: "rel",
  target: "target",
  title: "title",
  className: "class",
}),
_defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.IMAGE, {
  src: "src",
  height: "height",
  width: "width",
  alt: "alt",
  className: "class",
}),
_ENTITY_ATTR_MAP);

// Map entity data to element attributes.
const DATA_TO_ATTR = ((_DATA_TO_ATTR = {}),
_defineProperty(
  _DATA_TO_ATTR,
  _draftJsUtils.ENTITY_TYPE.LINK,
  (entityType, entity) => {
    const attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType)
      ? ENTITY_ATTR_MAP[entityType]
      : {};
    const data = entity.getData();
    const attrs = {};
    let _iteratorNormalCompletion = true;
    let _didIteratorError = false;
    let _iteratorError;

    try {
      for (
        var _iterator = Object.keys(data)[Symbol.iterator](), _step;
        !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
        _iteratorNormalCompletion = true
      ) {
        const dataKey = _step.value;

        const dataValue = data[dataKey];
        if (attrMap.hasOwnProperty(dataKey)) {
          const attrKey = attrMap[dataKey];
          attrs[attrKey] = dataValue;
        } else if (DATA_ATTRIBUTE.test(dataKey)) {
          attrs[dataKey] = dataValue;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return attrs;
  },
),
_defineProperty(
  _DATA_TO_ATTR,
  _draftJsUtils.ENTITY_TYPE.IMAGE,
  (entityType, entity) => {
    const attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType)
      ? ENTITY_ATTR_MAP[entityType]
      : {};
    const data = entity.getData();
    const attrs = {};
    let _iteratorNormalCompletion2 = true;
    let _didIteratorError2 = false;
    let _iteratorError2;

    try {
      for (
        var _iterator2 = Object.keys(data)[Symbol.iterator](), _step2;
        !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);
        _iteratorNormalCompletion2 = true
      ) {
        const dataKey = _step2.value;

        const dataValue = data[dataKey];
        if (attrMap.hasOwnProperty(dataKey)) {
          const attrKey = attrMap[dataKey];
          attrs[attrKey] = dataValue;
        } else if (DATA_ATTRIBUTE.test(dataKey)) {
          attrs[dataKey] = dataValue;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return attrs;
  },
),
_DATA_TO_ATTR);

// The reason this returns an array is because a single block might get wrapped
// in two tags.
function getTags(blockType, defaultBlockTag) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
      return ["h1"];
    case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
      return ["h2"];
    case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
      return ["h3"];
    case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
      return ["h4"];
    case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
      return ["h5"];
    case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
      return ["h6"];
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return ["li"];
    case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
      return ["blockquote"];
    case _draftJsUtils.BLOCK_TYPE.CODE:
      return ["pre", "code"];
    case _draftJsUtils.BLOCK_TYPE.ATOMIC:
      return ["figure"];
    default:
      if (defaultBlockTag === null) {
        return [];
      }
      return [defaultBlockTag || "p"];
  }
}

function getWrapperTag(blockType) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
      return "ul";
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return "ol";
    default:
      return null;
  }
}

const MarkupGenerator = (function() {
  // These are related to user-defined options.
  function MarkupGenerator(contentState, options) {
    _classCallCheck(this, MarkupGenerator);

    if (options == null) {
      options = {};
    }
    this.contentState = contentState;
    this.options = options;

    const _combineOrderedStyles = (0, _combineOrderedStyles4.default)(
      options.inlineStyles,
      [DEFAULT_STYLE_MAP, DEFAULT_STYLE_ORDER],
    );

    const _combineOrderedStyles2 = _slicedToArray(_combineOrderedStyles, 2);

    const inlineStyles = _combineOrderedStyles2[0];

    const styleOrder = _combineOrderedStyles2[1];

    this.inlineStyles = inlineStyles;
    this.inlineStyleFn = options.inlineStyleFn;
    this.styleOrder = styleOrder;
  }
  // These are related to state.

  _createClass(MarkupGenerator, [
    {
      key: "generate",
      value: function generate() {
        this.output = [];
        this.blocks = this.contentState.getBlocksAsArray();
        this.totalBlocks = this.blocks.length;
        this.currentBlock = 0;
        this.lastBlock = "";
        this.ordered_list_count = 0;
        this.ordered_list_type = null;
        this.indentLevel = 0;
        this.wrapperTag = null;
        while (this.currentBlock < this.totalBlocks) {
          this.processBlock();
        }
        this.closeWrapperTag();
        return this.output.join("").trim();
      },
    },
    {
      key: "processBlock",
      value: function processBlock() {
        const _options = this.options;

        const blockRenderers = _options.blockRenderers;

        const defaultBlockTag = _options.defaultBlockTag;

        const block = this.blocks[this.currentBlock];

        const elementStyle = block.data.get("elementStyle", "");

        const blockType = block.getType();

        const newWrapperTag = getWrapperTag(blockType);

        // this.ordered_list_type is actually prev type:(not 100% sure)
        if (block.type !== this.ordered_list_type) {
          this.ordered_list_count = 0;

          const listLevel = block.type.split("-")[2];
          let i = this.currentBlock - 1;
          while (i >= 0) {
            const type = this.blocks[i].getType();
            if (
              listLevel - 1 === parseInt(type.split("-")[2]) ||
              !type.includes("list")
            ) {
              break;
            }

            if (block.type === this.blocks[i].getType()) {
              this.ordered_list_count += 1;
            }

            i--;
          }
          this.ordered_list_type = null;
        }

        if (
          this.lastBlock !== blockType &&
          this.lastBlock.startsWith("unordered-list")
        ) {
          this.output.push("</ul>");
        }

        if (
          this.lastBlock !== blockType &&
          this.lastBlock.startsWith("ordered-list")
        ) {
          this.output.push("</ol>");
        }

        if (
          this.lastBlock !== blockType &&
          blockType.startsWith("unordered-list")
        ) {
          this.output.push("<ul>");
        }

        if (
          this.lastBlock !== blockType &&
          blockType.startsWith("ordered-list")
        ) {
          this.output.push("<ol>");
        }

        if (block.type === "plist") {
          if (elementStyle) {
            this.output.push(
              `<div class='plist-inline' style='${elementStyle}'>`,
            );
            this.output.push(this.renderBlockContent(block));
            this.output.push("</div>\n");
            this.currentBlock += 1;
            this.lastBlock = blockType;
            return;
          }
        }

        if (block.type.startsWith("unordered-list")) {
          // get the list level
          const level = block.type.split("-")[2];
          const levelNum =
            Number(level).toString() === level ? parseInt(level, 10) : 1;
          const divStyle =
            elementStyle && typeof elementStyle === "string"
              ? elementStyle
                  .split(";")
                  .map(style => {
                    if (style.startsWith("margin-left")) {
                      return `margin-left:${levelNum * DRAFT_TAB_LENGTH}px;`;
                    }
                    return style;
                  })
                  .join(";")
              : `margin-left:${levelNum * DRAFT_TAB_LENGTH - 16}px;`;

          const listStyles = `display: list-item; list-style-type: ${
            UNORDERED_LIST_TYPES[levelNum % UNORDERED_LIST_TYPES.length]
          };`;
          this.output.push(
            `<div classname="unordered-list" style='${divStyle} display: flex;'>`,
          );
          this.output.push(
            `<li id='${block.type}' classname='${
              block.type
            }' style='${listStyles}'>`,
          );
          this.output.push(this.renderBlockContent(block));
          this.output.push("</li>");
          this.output.push("</div>");
          this.currentBlock += 1;
          this.lastBlock = blockType;
          return;
        }

        if (block.type.startsWith("ordered-list")) {
          this.ordered_list_count += 1;
          this.ordered_list_type = block.type;
          const level = block.type.split("-")[2];
          const levelNum =
            Number(level).toString() === level ? parseInt(level, 10) : 1;
          const divStyle =
            elementStyle && typeof elementStyle === "string"
              ? elementStyle
                  .split(";")
                  .map(style => {
                    if (style.startsWith("margin-left")) {
                      return `margin-left:${levelNum * DRAFT_TAB_LENGTH}px;`;
                    }
                    return style;
                  })
                  .join(";")
              : `margin-left:${levelNum * DRAFT_TAB_LENGTH - 16}px;`;

          const listStyles = `display: list-item; list-style-type: ${
            ORDERED_LIST_TYPES[(levelNum - 1) % ORDERED_LIST_TYPES.length]
          };`;
          this.output.push(
            `<div classname="ordered-list"  style='${divStyle}; display: flex;'>`,
          );
          this.output.push(
            `<li id='${block.type}' classname='${
              block.type
            }' style='${listStyles}' value='${this.ordered_list_count}'>`,
          );
          this.output.push(this.renderBlockContent(block));
          this.output.push("</li>");
          this.output.push("</div>");
          this.currentBlock += 1;
          this.lastBlock = blockType;
          return;
        }

        if (elementStyle) {
          const tag = getTags(blockType)[0];
          this.output.push(
            `<${tag} class=${blockType} style='${elementStyle}'>`,
          );
          this.output.push(this.renderBlockContent(block));
          this.output.push(`</${tag}\n>`);
          this.currentBlock += 1;
          this.lastBlock = blockType;
          return;
        }

        if (blockType.startsWith("header")) {
          const tag = getTags(blockType)[0];
          this.output.push(`<${tag} class=${blockType}>`);
          this.output.push(this.renderBlockContent(block));
          this.output.push(`</${tag}\n>`);
          this.currentBlock += 1;
          this.lastBlock = blockType;
          return;
        }

        if (this.wrapperTag !== newWrapperTag) {
          if (this.wrapperTag) {
            this.closeWrapperTag();
          }
          if (newWrapperTag) {
            this.openWrapperTag(newWrapperTag);
          }
        }
        this.indent();
        // Allow blocks to be rendered using a custom renderer.
        const customRenderer =
          blockRenderers != null && blockRenderers.hasOwnProperty(blockType)
            ? blockRenderers[blockType]
            : null;
        const customRendererOutput = customRenderer
          ? customRenderer(block)
          : null;
        // Renderer can return null, which will cause processing to continue as normal.

        if (customRendererOutput != null) {
          this.output.push(customRendererOutput);
          this.output.push("\n");
          this.currentBlock += 1;
          this.lastBlock = blockType;
          return;
        }
        this.writeStartTag(block, defaultBlockTag);
        this.output.push(this.renderBlockContent(block));
        // Look ahead and see if we will nest list.
        const nextBlock = this.getNextBlock();
        if (
          canHaveDepth(blockType) &&
          nextBlock &&
          nextBlock.getDepth() === block.getDepth() + 1
        ) {
          this.output.push("\n");
          // This is a litle hacky: temporarily stash our current wrapperTag and
          // render child list(s).
          const thisWrapperTag = this.wrapperTag;
          this.wrapperTag = null;
          this.indentLevel += 1;
          this.currentBlock += 1;
          this.processBlocksAtDepth(nextBlock.getDepth());
          this.wrapperTag = thisWrapperTag;
          this.indentLevel -= 1;
          this.indent();
        } else {
          this.currentBlock += 1;
        }
        this.lastBlock = blockType;
        this.writeEndTag(block, defaultBlockTag);
      },
    },
    {
      key: "processBlocksAtDepth",
      value: function processBlocksAtDepth(depth) {
        let block = this.blocks[this.currentBlock];
        while (block && block.getDepth() === depth) {
          this.processBlock();
          block = this.blocks[this.currentBlock];
        }
        this.closeWrapperTag();
      },
    },
    {
      key: "getNextBlock",
      value: function getNextBlock() {
        return this.blocks[this.currentBlock + 1];
      },
    },
    {
      key: "writeStartTag",
      value: function writeStartTag(block, defaultBlockTag) {
        const tags = getTags(block.getType(), defaultBlockTag);

        let attrString = void 0;
        if (this.options.blockStyleFn) {
          const _ref = this.options.blockStyleFn(block) || {};

          let _attributes = _ref.attributes;

          const _style = _ref.style;
          // Normalize `className` -> `class`, etc.

          _attributes = (0, _normalizeAttributes2.default)(_attributes);
          if (_style != null) {
            const styleAttr = (0, _styleToCSS2.default)(_style);
            _attributes =
              _attributes == null
                ? { style: styleAttr }
                : _extends({}, _attributes, { style: styleAttr });
          }
          attrString = stringifyAttrs(_attributes);
        } else {
          attrString = "";
        }

        let _iteratorNormalCompletion3 = true;
        let _didIteratorError3 = false;
        let _iteratorError3;

        try {
          for (
            var _iterator3 = tags[Symbol.iterator](), _step3;
            !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done);
            _iteratorNormalCompletion3 = true
          ) {
            const tag = _step3.value;

            this.output.push(`<${tag}${attrString}>`);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      },
    },
    {
      key: "writeEndTag",
      value: function writeEndTag(block, defaultBlockTag) {
        const tags = getTags(block.getType(), defaultBlockTag);
        if (tags.length === 1) {
          this.output.push(`</${tags[0]}>\n`);
        } else {
          const output = [];
          let _iteratorNormalCompletion4 = true;
          let _didIteratorError4 = false;
          let _iteratorError4;

          try {
            for (
              var _iterator4 = tags[Symbol.iterator](), _step4;
              !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done);
              _iteratorNormalCompletion4 = true
            ) {
              const tag = _step4.value;

              output.unshift(`</${tag}>`);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          this.output.push(`${output.join("")}\n`);
        }
      },
    },
    {
      key: "openWrapperTag",
      value: function openWrapperTag(wrapperTag) {
        this.wrapperTag = wrapperTag;
        this.indent();
        this.output.push(`<${wrapperTag}>\n`);
        this.indentLevel += 1;
      },
    },
    {
      key: "closeWrapperTag",
      value: function closeWrapperTag() {
        const wrapperTag = this.wrapperTag;

        if (wrapperTag) {
          this.indentLevel -= 1;
          this.indent();
          this.output.push(`</${wrapperTag}>\n`);
          this.wrapperTag = null;
        }
      },
    },
    {
      key: "indent",
      value: function indent() {
        this.output.push(INDENT.repeat(this.indentLevel));
      },
    },
    {
      key: "withCustomInlineStyles",
      value: function withCustomInlineStyles(content, styleSet) {
        if (!this.inlineStyleFn) {
          return content;
        }

        const renderConfig = this.inlineStyleFn(styleSet);
        if (!renderConfig) {
          return content;
        }

        const _renderConfig$element = renderConfig.element;

        const element =
          _renderConfig$element === undefined ? "span" : _renderConfig$element;

        const attributes = renderConfig.attributes;

        const style = renderConfig.style;

        const attrString = stringifyAttrs(
          _extends({}, attributes, {
            style: style && (0, _styleToCSS2.default)(style),
          }),
        );

        return `<${element}${attrString}>${content}</${element}>`;
      },
    },
    {
      key: "renderBlockContent",
      value: function renderBlockContent(block) {
        const _this = this;

        const blockType = block.getType();
        let text = block.getText();
        if (text === "") {
          // Prevent element collapse if completely empty.
          return BREAK;
        }
        text = this.preserveWhitespace(text);
        const charMetaList = block.getCharacterList();
        const entityPieces = (0, _draftJsUtils.getEntityRanges)(
          text,
          charMetaList,
        );
        return entityPieces
          .map(_ref2 => {
            const _ref3 = _slicedToArray(_ref2, 2);

            const entityKey = _ref3[0];

            const stylePieces = _ref3[1];

            const content = stylePieces
              .map(_ref4 => {
                const _ref5 = _slicedToArray(_ref4, 2);

                const text = _ref5[0];

                const styleSet = _ref5[1];

                let content = encodeContent(text);
                let _iteratorNormalCompletion5 = true;
                let _didIteratorError5 = false;
                let _iteratorError5;

                try {
                  for (
                    var _iterator5 = _this.styleOrder[Symbol.iterator](),
                      _step5;
                    !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next())
                      .done);
                    _iteratorNormalCompletion5 = true
                  ) {
                    const _styleName = _step5.value;

                    // If our block type is CODE then don't wrap inline code elements.
                    if (
                      _styleName === CODE &&
                      blockType === _draftJsUtils.BLOCK_TYPE.CODE
                    ) {
                      continue;
                    }
                    if (styleSet.has(_styleName)) {
                      const _inlineStyles$_styleN =
                        _this.inlineStyles[_styleName];

                      let _element = _inlineStyles$_styleN.element;

                      let _attributes2 = _inlineStyles$_styleN.attributes;

                      const _style2 = _inlineStyles$_styleN.style;

                      if (_element == null) {
                        _element = "span";
                      }
                      // Normalize `className` -> `class`, etc.
                      _attributes2 = (0, _normalizeAttributes2.default)(
                        _attributes2,
                      );
                      if (_style2 != null) {
                        const styleAttr = (0, _styleToCSS2.default)(_style2);
                        _attributes2 =
                          _attributes2 == null
                            ? { style: styleAttr }
                            : _extends({}, _attributes2, { style: styleAttr });
                      }
                      const attrString = stringifyAttrs(_attributes2);
                      content = `<${_element}${attrString}>${content}</${_element}>`;
                    }
                  }
                } catch (err) {
                  _didIteratorError5 = true;
                  _iteratorError5 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                      _iterator5.return();
                    }
                  } finally {
                    if (_didIteratorError5) {
                      throw _iteratorError5;
                    }
                  }
                }

                return _this.withCustomInlineStyles(content, styleSet);
              })
              .join("");
            const entity = entityKey
              ? _this.contentState.getEntity(entityKey)
              : null;
            // Note: The `toUpperCase` below is for compatability with some libraries that use lower-case for image blocks.
            const entityType =
              entity == null ? null : entity.getType().toUpperCase();
            let entityStyle = void 0;
            if (
              entity != null &&
              _this.options.entityStyleFn &&
              (entityStyle = _this.options.entityStyleFn(entity))
            ) {
              const _entityStyle = entityStyle;

              let _element2 = _entityStyle.element;

              let _attributes3 = _entityStyle.attributes;

              const _style3 = _entityStyle.style;

              if (_element2 == null) {
                _element2 = "span";
              }
              // Normalize `className` -> `class`, etc.
              _attributes3 = (0, _normalizeAttributes2.default)(_attributes3);
              if (_style3 != null) {
                const styleAttr = (0, _styleToCSS2.default)(_style3);
                _attributes3 =
                  _attributes3 == null
                    ? { style: styleAttr }
                    : _extends({}, _attributes3, { style: styleAttr });
              }
              const attrString = stringifyAttrs(_attributes3);

              // fill form field value in html directly
              if (
                entityType === _documentConstants.DRAFT_ENTITY.DYNAMICFIELD &&
                _attributes3.value
              )
                return `<${_element2}${attrString}>${
                  _attributes3.value
                }</${_element2}>`;

              return `<${_element2}${attrString}>${content}</${_element2}>`;
            }
            if (
              entityType != null &&
              entityType === _draftJsUtils.ENTITY_TYPE.LINK
            ) {
              const attrs = DATA_TO_ATTR.hasOwnProperty(entityType)
                ? DATA_TO_ATTR[entityType](entityType, entity)
                : null;
              const _attrString = stringifyAttrs(attrs);
              return `<a${_attrString}>${content}</a>`;
            }
            if (
              entityType != null &&
              entityType === _draftJsUtils.ENTITY_TYPE.IMAGE
            ) {
              const _attrs = DATA_TO_ATTR.hasOwnProperty(entityType)
                ? DATA_TO_ATTR[entityType](entityType, entity)
                : null;
              const _attrString2 = stringifyAttrs(_attrs);
              return `<img${_attrString2}/>`;
            }
            return content;
          })
          .join("");
      },
    },
    {
      key: "preserveWhitespace",
      value: function preserveWhitespace(text) {
        const length = text.length;
        // Prevent leading/trailing/consecutive whitespace collapse.
        const newText = new Array(length);
        for (let i = 0; i < length; i++) {
          if (
            text[i] === " " &&
            (i === 0 || i === length - 1 || text[i - 1] === " ")
          ) {
            newText[i] = "\xA0";
          } else {
            newText[i] = text[i];
          }
        }
        return newText.join("");
      },
    },
  ]);

  return MarkupGenerator;
})();

function stringifyAttrs(attrs) {
  if (attrs == null) {
    return "";
  }
  const parts = [];
  let _iteratorNormalCompletion6 = true;
  let _didIteratorError6 = false;
  let _iteratorError6;

  try {
    for (
      var _iterator6 = Object.keys(attrs)[Symbol.iterator](), _step6;
      !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done);
      _iteratorNormalCompletion6 = true
    ) {
      const name = _step6.value;

      const value = attrs[name];
      if (value != null) {
        parts.push(` ${name}="${encodeAttr(`${value}`)}"`);
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return parts.join("");
}

function canHaveDepth(blockType) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return true;
    default:
      return false;
  }
}

function encodeContent(text) {
  return text
    .split("&")
    .join("&amp;")
    .split("<")
    .join("&lt;")
    .split(">")
    .join("&gt;")
    .split("\xA0")
    .join("&nbsp;")
    .split("\n")
    .join(`${BREAK}\n`);
}

function encodeAttr(text) {
  return text
    .split("&")
    .join("&amp;")
    .split("<")
    .join("&lt;")
    .split(">")
    .join("&gt;")
    .split('"')
    .join("&quot;");
}

function stateToHTML(content, options) {
  return new MarkupGenerator(content, options).generate();
}
